module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-header"
  }, [_c('x-header', [_vm._v("库存流水")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-content"
  }, [_c('group', _vm._l((_vm.balanceList), function(log) {
    return _c('cell', {
      key: log.id,
      attrs: {
        "value": log.amount,
        "link": '/uc/orderDetail/' + log.order_id,
        "disabled": log.order_id === 0,
        "is-link": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(log.desc))]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": ""
      },
      slot: "default"
    }, [_c('div', [_vm._v(_vm._s(log.desc))]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
      staticClass: "desc",
      attrs: {
        "slot": "inline-desc"
      },
      slot: "inline-desc"
    }, [(log.order_id > 0) ? _c('div', [_vm._v("订单ID：" + _vm._s(log.order_id))]) : _vm._e()])])
  })), _vm._v(" "), _c('infinite-loading', {
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('divider', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("没有更多数据了")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70d5eb37"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/PromiseBalance.vue
// module id = 717
// module chunks = 0